/**
 * Keeps publisher-entity server filter semantics shared between Ads Manager
 * tables and aggregate count displays so their status buckets cannot drift.
 */
import type {
  EntityStatus,
  SyncStatus,
} from 'src/store/generated/leela-api-generated';

export type AdsStatusFilter = 'ALL' | 'LIVE' | 'PENDING' | 'PROCESSING' | 'FAILED' | 'REMOVED';

export interface StatusFilterParams {
  entityStatus?: EntityStatus;
  syncStatus?: SyncStatus;
}

// The Pending badge also covers SYNCED ads with no entityStatus, but the
// backend's single-value filters cannot isolate that residual legacy state.
export const ADS_STATUS_FILTER_PARAMS: Record<AdsStatusFilter, StatusFilterParams> = {
  ALL: {},
  FAILED: { syncStatus: 'FAILED' },
  LIVE: { entityStatus: 'IN_STOCK', syncStatus: 'SYNCED' },
  PENDING: { syncStatus: 'PENDING' },
  PROCESSING: { syncStatus: 'PROCESSING' },
  REMOVED: { entityStatus: 'OUT_OF_STOCK', syncStatus: 'SYNCED' },
};
